<!--
 * @Author:
 * @LastEditTime: 2023-07-28
 * @Description: 承包商开工许可指引
-->
<template>
  <el-card class="h-full relative">
    <div class="h-full" v-if="!isStart">
      <div class="h-full flex flex-col">
        <div class="pt-18px text-16px flex-auto overflow-y-auto w-3/5 m-auto h-0">
          <h3 class="m-20px text-center font-bold">考试公告</h3>
          <!-- <p class="mt-10px">1、厂内作业具有较多的风险因素，请认真学习培训内容；</p>
          <p class="mt-10px">
            2、审核通过的人员，允许参加专项的培训课程，培训人需通过全部必修可，且获得要求的学分、学时，才可通过培训课程；
          </p>
          <p class="mt-10px">
            3、每个培训课件内，都包含多个节点，视频学习进度到达时，可以答题完成节点
          </p>
          <p class="mt-10px">
            4、未完成的节点不可快进跳过，未完成的节点进度不会被保存，请谨慎推出；
          </p>
          <p class="mt-10px">5、培训通过后，请在首页参加入厂考试，完成此阶段培训考试</p>
          <p class="mt-10px">6、未完成培训流程的员工将禁止入厂作业。</p> -->
          <div v-text="examNotice" class="whitespace-pre-wrap leading-loose mt-10px"></div>
        </div>
        <div class="text-center">
          <el-button size="small" type="primary" :disabled="!!startCountdown" @click="start"
            >开始考试{{ startCountdown | countdownStr }}</el-button
          >
          <el-button size="small" @click="goBack">取消</el-button>
        </div>
      </div>
    </div>
    <OnlineQuestionForm
      v-else
      :isNeedReplaceRoute="$route.query.isNeedReplaceRoute"
    ></OnlineQuestionForm>
  </el-card>
</template>

<script type="text/babel">
import { ExamTaskApi } from '@wiz-api/exam-management'
import dayjs from 'dayjs'
import OnlineQuestionForm from '../components/OnlineQuestion/OnlineQuestionForm'

const examTaskApi = new ExamTaskApi()
export default {
  name: 'online-question',
  components: {
    OnlineQuestionForm,
  },
  filters: {
    countdownStr(val) {
      if (val > 5 || val <= 0) {
        return ''
      }
      return `(${val}s)`
    },
  },
  data() {
    return {
      startCountdown: 5,
      timer: null,
      isStart: false,
      examInfo: {},
      examNotice:
        '1.考试前请认真听监考员阅读考试须知，熟知考试规则和细节。\n2.保证考试环境的安静，提前确定好网络是否通畅，考试中通不要离开座位。\n3.考试前请将手机调至静音，打开勿扰模式防止出现意外，影响考试。\n4.考试严格按照考试时间和流程参加考试，不得提前或延后，未在现定时间参加考试者，视为自愿放弃考试资格。\n5.参加考试，除应自行准备好考试必需品外，其他物品(包括手机、手表等其他电子设备、书本及学习资料等) 禁止带入考试答题区。\n6.考生需严格遵守考场纪律，服从工作人员指挥，违反规定者，取消考试资格。\n7.考区内严禁使用通讯工具， 违反规定者按作弊处理。',
    }
  },
  computed: {
    pageTags() {
      return this.$store.getters['System/pageTags']
    },
    dataId() {
      return this.$route.query.id
    },
  },
  methods: {
    async getExamTaskInfo() {
      const [err, res] = await examTaskApi.getInfo({
        examTaskId: this.dataId,
      })
      if (!err) {
        this.examInfo = res
        this.examNotice = res.examNotice ? res.examNotice : this.examNotice
      }
    },
    // 开始考试
    start() {
      this.isStart = true
    },
    // 返回
    async goBack() {
      if (this.$route.query.isNeedReplaceRoute === '1') {
        if (this.pageTags && this.pageTags.length > 1) {
          await this.$store.dispatch(
            'System/pageTags',
            _.filter(this.pageTags, (i) => {
              return i.path !== '/educational-training-management-sm/exam-manage/question-task'
            })
          )
        }
        this.$router.go(-2)
      } else {
        this.$router.go(-1)
      }
    },
    async createApi() {
      this.showOperateApiDialog = true
    },
    countdown() {
      const seconds = dayjs(this.examInfo.singleExamStartTime).diff(dayjs(), 'second')
      this.startCountdown = seconds > 0 ? seconds : 5
      this.timer = setInterval(() => {
        this.startCountdown = this.startCountdown - 1
        if (this.startCountdown === 0) {
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
  },
  async created() {
    await this.getExamTaskInfo()
    this.countdown()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  // height: calc(100% - 45px);
  height: 100%;
}
.bg_custom {
  background: rgba(237, 240, 249, 0.5);
}
.img_dialog {
  ::v-deep .el-dialog__body {
    padding-top: 0px;
  }
}

.required-text--color {
  color: #ff3a30;
}

.down-file--color {
  color: #acdbff;
}
</style>
